// React bağlayıcısı. `i18n.js` saf JavaScript kalsın diye ayrı dosya:
// sözlük parite testi React yüklemeden koşuyor.
import { createContext, useContext } from 'react';
import { DEFAULT_LANG, makeT } from './i18n.js';

export const LangContext = createContext(DEFAULT_LANG);

/** `const t = useT()` → `t('save')`, `t('tbl.seats', { n: 4 })`. */
export function useT() {
  return makeT(useContext(LangContext));
}

export function useLang() {
  return useContext(LangContext);
}

/**
 * Tarih/saat biçimi dile göre. Sabit `'tr-TR'` yazmak Almanca panelde Türk
 * biçimi gösteriyordu; `undefined` vermek de tarayıcının dilini kullanır,
 * personelin SEÇTİĞİ dili değil.
 */
export function useDateFmt() {
  const lang = useContext(LangContext);
  return {
    dateTime: (v) => (v ? new Date(v).toLocaleString(lang) : '—'),
    date: (v) => (v ? new Date(v).toLocaleDateString(lang) : '—'),
    number: (n) => new Intl.NumberFormat(lang).format(n),
  };
}
